import { render, staticRenderFns } from "./NotificationBadge.vue?vue&type=template&id=62088a8b&"
import script from "./NotificationBadge.vue?vue&type=script&lang=js&"
export * from "./NotificationBadge.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports